import {WebConfig} from "~/src/Model/WebConfig/WebConfig";
import * as process from 'process'

export const BaseWebConfig: WebConfig = {
    apiUrl: process.env.REACT_APP_API_URL as string,
    apiKey: process.env.REACT_APP_API_TOKEN as string ?? 'f5335db2-3efc-45a9-b46b-d96397b84ccd'
}
